import React from "react";
import BaseModal from "components/BaseModal";
import * as Styled from "../../styles";

interface DeleteProviderModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

function DeleteProviderModal({
  open,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteProviderModalProps) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Excluir"
      cancellationText="Cancelar"
      confirmationText={isDeleting ? "Excluindo..." : "Sim, desejo excluir"}
      cancellationCallback={onClose}
      confirmationCallback={onConfirm}
    >
      <Styled.ModalContent>
        <Styled.ModalTypography variant="h6">
          Você tem certeza que deseja excluir o provedor?
        </Styled.ModalTypography>
        <Styled.ImportantNotice>
          <Styled.ModalInfoIcon />
          <Styled.ModalImportantText component="span">
            <Styled.ModalImportantTextBold component="span">
              Importante:
            </Styled.ModalImportantTextBold>{" "}
            Esta ação é irreversível. O provedor será removido permanentemente e
            não poderá ser recuperado.
          </Styled.ModalImportantText>
        </Styled.ImportantNotice>
      </Styled.ModalContent>
    </BaseModal>
  );
}

export default DeleteProviderModal;
